<template>
    <div
        class="pt-1 right-bar"
        :class="{
            'dark-theme': $vuetify.theme.dark,
            'white-theme': !$vuetify.theme.dark
        }"
    >
        <bet-popover
            v-if="
                selectedBetfairId.betfairId ||
                selectedBetfairId.id ||
                selectedBetfairId.marketId
            "
            :check-id="
                selectedBetfairId.betfairId ||
                selectedBetfairId.id ||
                selectedBetfairId.marketId
            "
            :class="{ 'shake-now': shake }"
            @getPopoverHeight="getPopoverHeight"
        ></bet-popover>
        <!-- class="hits-sticky" -->
        <div>
            <my-bets
                v-if="isPageLoaded"
                :show-live="showLive"
                :show-score="showScore"
                :tv-score-position-switch="tvScorePositionSwitch"
                :popover-height="popoverHeight"
                class="hits-sticky"
            ></my-bets>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex"
import MyBets from "@/components/MyBets"
import BetPopover from "@/components/BetPopover"

export default {
    components: {
        MyBets,
        BetPopover
    },
    props: {
        showBetslip: { type: Boolean, default: true, required: false },
        showLive: { type: Boolean, default: false, required: false },
        showScore: { type: Boolean, default: false, required: false },
        tvScorePositionSwitch: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            refresh: true,
            shake: false,
            tabs: 1,
            isPageLoaded: false, // New data property
            popoverHeight: 0
        }
    },
    computed: {
        ...mapState({
            selectedBetfairId: (state) => state.placeBet.runner
        }),
        pageIsLoaded() {
            return this.isPageLoaded
        }
    },
    watch: {
        selectedBetfairId(v) {
            if (v) {
                if (this.tabs === 0 && (v.betfairId || v.id || v.marketId)) {
                    this.shake = true
                    setTimeout(() => {
                        this.shake = false
                    }, 300)
                }
                if ((v.betfairId || v.id || v.marketId) && this.showBetslip) {
                    this.tabs = 0
                    // console.log('1', v)
                } else {
                    this.tabs = 1
                    // console.log('2', v)
                }
                // if (!v.betfairId || !v.id) {
                //   console.log('3', v)
                //   this.tabs = 1
                // }
            }
        }
    },
    mounted() {
        if (document.readyState === "complete") {
            this.isPageLoaded = true
        } else {
            window.addEventListener("load", this.handlePageLoad)
        }
    },
    beforeDestroy() {
        window.removeEventListener("load", this.handlePageLoad)
    },
    methods: {
        handlePageLoad() {
            this.isPageLoaded = true
        },
        getPopoverHeight(refValue) {
            this.popoverHeight = refValue
        }
    }
}
</script>
<style lang="scss">
.right-bar.white-theme {
    .theme--light.v-tabs > .v-tabs-bar {
        background-color: #e1e1e1 !important;
    }
    .theme--light.v-tabs-items {
        background-color: #e1e1e1 !important;
        border-bottom-left-radius: 0.5rem;
        border-bottom-right-radius: 0.5rem;
    }
}
.v-tabs.bet-tablist {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
</style>
